import { AbstractFormFragment } from '@components/form/AbstractFormFragment';

export class TextFieldFormFragment extends AbstractFormFragment {
  static getCssClassName(): string {
    return 'comp-form-text';
  }

  private getInput(): HTMLInputElement | null {
    return this.node.querySelector<HTMLInputElement>('input');
  }

  hasValue(): boolean {
    return !!(this.getInput()?.value);
  }

  getErrorIndicatorNode(): HTMLElement | null {
    return this.getInput();
  }

  attachChangeListener(callback: () => void): this {
    this.getInput()?.addEventListener('input', () => {
      this.triggerDelayed(callback);
    });
    return this;
  }
}

export default TextFieldFormFragment;
